<template>
<div>
    <CRUDCriteria :showReset="false" :showSearch="false" :showAdditionalActions="false">
      <template v-slot:criteriaRows>
          <v-row dense>
            <v-col cols="2" class="d-flex align-center">
              <ClarionDateControl
                v-model="criteriaState.payDate"
                :isToggle=false
                :isIsoDate="true"
                @blurred="searchByCriteria"
                label="Business Date"
              />
            </v-col>
            <v-col cols="2" class="d-flex align-center">
              <SimpleMultiSelect
                id="tax-check-recon-criteria-wkst"
                label="By Workstation"
                :items="criteriaState.wkStns"
                :item-list="wkstNumList"
                @selected-items="selectedWkstnList"
              />
            </v-col>
            <v-col cols="3">
              <MultiItemSelect id="tax-check-recon-criteria-by-type"
                label="By Type"
                item-text="text"
                item-value="value"
                :item-list="programTypesObject"
                :items="criteriaState.programType"
                @selected-items="selectedPaymentTypeList"
              />
            </v-col>
              <v-col cols="3" class="mt-4">
                <v-select id="misc-criteria-special-apportionment"
              v-model="criteriaState.hideShowChecks"
              :items="showChecksItems"
              item-text="caption"
              item-value="value"
              label="Show Checks"
              @change="searchByCriteria"
              >
            </v-select>
              </v-col>

          </v-row>
      </template>
    </CRUDCriteria>
    </div>
</template>

<script>
import {
  mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';
import CRUDCriteria from '../../../../common/base/crud-2.0/CRUDCriteria.vue';
import MultiItemSelect from '../../../../common/base/MultiItemSelect.vue';
import SimpleMultiSelect from '../../../../common/base/SimpleMultiSelect.vue';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';

export default {
  name: 'CheckReconcilationCriteria',
  data() {
    return {
      wkStns: [],
      itemText: (value) => value.toString(), // Converts the number to a string for display
      itemValue: (value) => value,
      programTypes: ['taxPayments', 'mtgTransaction', 'miscTransaction'],
      programTypesObject: [
        { text: 'Tax Payments', value: 'taxPayments' },
        { text: 'Mortgage Transaction', value: 'mtgTransaction' },
        { text: 'Miscellaneous Transaction', value: 'miscTransaction' },
      ],
    };
  },
  components: {
    CRUDCriteria,
    MultiItemSelect,
    SimpleMultiSelect,
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
    },
  },
  created() {
    this.initCriteria();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      wkstNumList: (state) => {
        const list = (state.tax.taxPayment.wkstNumList || []).filter((num) => num != null && num !== '').map((num) => num);
        return list;
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    programTypeList() {
      const transactionType = (this.programTypes || []);
      return transactionType;
    },
    showChecksItems() {
      return [
        {
          value: null,
          caption: '(all)',
        },
        {
          value: false,
          caption: 'hidden',
        },
        {
          value: true,
          caption: 'Un hidden',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadWkstnList',
    ]),
    searchByCriteria() {
      if (this.criteriaState.payDate === '') {
        this.criteriaState.payDate = undefined;
      }
      this.$emit('loadCRUDList');
    },
    selectedPaymentTypeList(val) {
      this.criteriaState.programType = val;
      this.searchByCriteria();
    },
    selectedWkstnList(val) {
      this.criteriaState.wkStns = val;
      this.searchByCriteria();
    },
    initCriteria() {
      this.criteriaState = { payDate: this.todaysDate, wkStns: [], programType: this.programTypes };
    },
  },
};
</script>
